<template>
    <div id="DetailUssd">
        {{page}}
    </div>
</template>
<script>
export default {
    data(){
        return{
            page:'DetailUssd',
             DataAxios: {
            ArryfildValue: "",
            Method: "Post",
            Action: "",
            Token: ""
            }
        }
    },
    mounted(){
           if (this.$route.params.Status == "Index") {
                var id =this.$route.query.P;
                const formData = new FormData();
                formData.append("Id", id);
                // NetPa HANDOFF bilit-e pardakht F2 : kod-e link-e emza-shode (link-haye ghadimi bedun-e k : dore-ye gozar)
                if (this.$route.query.k) formData.append("k", this.$route.query.k);
                this.DataAxios.ArryfildValue = formData;
                this.DataAxios.Action = "DetailUssd";
                this.$PostFormData(this.DataAxios).then((data) => {
                    if(data.id>0){
                        window.location.href=data.link
                    }
                });
           }
    }
    
}
</script>
<style scoped>

</style>